<script lang="ts">
  import { locale } from "$lib/services/i18n";
  export let macro = false;
  export let href: string;
  export let className = "";

  function getSlug(href: string) {
    if (href.charAt(0) === "/") {
      href = href.substring(1);
    }
    return `/${$locale}/${href}`.replace("/en/", "/");
  }

  $: slug = getSlug(href);
</script>

<a {...macro && { itemprop: "item" }} href={slug} class={`${className}`} on:click><slot /></a>

<style lang="scss">
  a {
    padding: 0;
    margin: 0;
    cursor: pointer;
    text-decoration: none;
  }
</style>
